import { controls } from "../../controls";

const rp611 = {
  label: "Sugar Factory Unitwise Exposure ",
  pageLabel: "Sugar Factory Unitwise Exposure ",
  starting: true,
  url: "rp611",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),


    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Sugar Factory Unitwise Expiry ",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    clickable: true, //?

    extraRows: {
      fields: ["pledgesanction", "pledgeoutstanding", "hpsanction", "hpoutstanding", "preseasonalloan", "intrsanction", "introutstanding", "stloansanction", "stloanoutstanding",
        "mtloansanction", "mtloanoutstanding", "mtconsortiumsanction", "mtconsortiumoutstanding", "ltloansanction", "ltloanoutstanding",
        "restloansanction", "restloanoutstanding", "total_loan_limit_section"],
      subtotals: {
        by: "brcode",
        displayIn: "descn",
        groupsOnly: false,
        location: "bottom",
      },
      grandtotal: { type: "fixed", displayIn: "descn", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },



    displayColumns: [
      {

        Header: "Customer Id",
        accessor: "cin",
        width: 80



      },
      {

        Header: "A/C code",
        accessor: "acctcode",
        width: 150



      },
      {

        Header: "A/C Name",
        accessor: "descn",
        width: 200



      },
      {
        Header: "Pledge Loan",
        columns: [
          {
            Header: "Sanction",
            accessor: "pledgesanction"


          },
          {
            Header: "Outstanding",
            accessor: "pledgeoutstanding"



          }

        ]
      },

      {
        Header: "Hypothication",
        columns: [
          {
            Header: "Sanction",
            accessor: "hpsanction"

          },
          {
            Header: "Outstanding",
            accessor: "hpoutstanding"

          }

        ]
      },


      {
        Header: "Outstanding Amount",
        columns: [
          {
            Header: "Personal Loan",
            accessor: "preseasonalloan"


          },
          {
            Header: "S.T & Interium Loan",
            accessor: "shorttermandinteriumoutstanding"
            ,


          },
          {
            Header: "M.T Loan Outstanding",
            accessor: "mtloanoutstanding"



          },

          {
            Header: "Undisbursed Amount",
            accessor: "undisbursedamount"



          }

        ]
      },


      {
        Header: "Outstanding Amount",
        columns: [
          {
            Header: "M.T Consortium Loan",
            accessor: "mtconsortiumloan"



          },
          {
            Header: "Restructured Long Term Loan",
            accessor: "longtermloan"



          },
          {
            Header: "Bank Gurantee 80%",
            accessor: "bankguarantee"



          }
        ]
      },

      {

        Header: "Total Exposure",
        accessor: "bankguarantee"





      }


    ]
  }
};

export default rp611;